import { Selector } from '@ngxs/store';
import {
  MyGroupInvitationsState,
  MyGroupInvitationsStateModel,
} from './my-group-invitations.state';
import { GroupDetailsDto } from '@smatchy/sdk';

export class MyGroupInvitationsSelector {
  @Selector([MyGroupInvitationsState])
  static loading(state: MyGroupInvitationsStateModel): boolean {
    return state.loading;
  }

  @Selector([MyGroupInvitationsState])
  static invitations(state: MyGroupInvitationsStateModel): GroupDetailsDto[] {
    return state.invitations;
  }

  @Selector([MyGroupInvitationsState])
  static hasInvitations(state: MyGroupInvitationsStateModel): boolean {
    return state.invitations.length > 0;
  }

  @Selector([MyGroupInvitationsState])
  static processingGroupId(state: MyGroupInvitationsStateModel): string | null {
    return state.processingGroupId;
  }
}

